import { COMPLIANCE_NOTICE, SHORT_COMPLIANCE_NOTICE, PRIVACY_PATH } from '../content/legal';

export const ComplianceNotice = ({ short = false, testId, className = '' }) => (
  <p data-testid={testId} className={`text-sm leading-relaxed ${className}`}>
    {short ? SHORT_COMPLIANCE_NOTICE : COMPLIANCE_NOTICE}
  </p>
);

export const FormPrivacyConsent = ({ testId, className = '' }) => (
  <p data-testid={testId} className={`text-sm leading-relaxed text-gray-600 ${className}`}>
    By submitting this form you agree to GenMoney contacting you about your enquiry. See our{' '}
    <a data-testid={`${testId}-link`} href={PRIVACY_PATH} target="_blank" rel="noopener noreferrer" className="text-[#7c4a97] underline underline-offset-2">Privacy Notice</a>{' '}
    for how we use your data.
  </p>
);